module.exports = __webpack_public_path__ + "img/plant2.c35ff82f.jpg";